import {throttle} from 'lodash';
import {useCallback, useEffect, useRef, useState} from 'react';
import styled from 'styled-components';
import {Typography} from '@/components/Typography';
import {MAP_LAYER_Z_INDEX} from '@/map/constants';
import {interceptProps} from '@/styled-components';
import {palette} from '@/styles';
import {Marker} from '../../Overlay';

interface IProps extends IContentProps {
  map: naver.maps.Map;
}

interface IContentProps {
  hint: string;
  borderColor?: string;
  color?: string;
}

export const RulerCursor = ({map, hint, color, borderColor}: IProps) => {
  const evt = useRef<naver.maps.MapEventListener>();
  const [position, setPosition] = useState<naver.maps.LatLng | undefined>();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const onMousemoveEvent = useCallback(
    throttle((e: {coord: naver.maps.LatLng}) => {
      setPosition(e.coord);
    }, 50),
    [setPosition]
  );

  useEffect(() => {
    evt.current = naver.maps.Event.addListener(
      map,
      'mousemove',
      onMousemoveEvent
    );

    return () => {
      if (evt.current) {
        naver.maps.Event.removeListener(evt.current);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map]);

  if (!position) {
    return null;
  }

  return (
    <Marker
      map={map}
      position={position}
      draggable={false}
      clickable={false}
      zIndex={MAP_LAYER_Z_INDEX.MAP_CURSOR}
    >
      <Content hint={hint} borderColor={borderColor} color={color} />
    </Marker>
  );
};

const Content = ({hint, color, borderColor, ...props}: IContentProps) => {
  return (
    <Root borderColor={borderColor} {...props}>
      <Typography as="div" variant="medium12" color={color ?? palette.gray600}>
        {hint}
      </Typography>
    </Root>
  );
};

const Root = styled('div').withConfig({
  shouldForwardProp: interceptProps(['borderColor']),
})<{
  borderColor?: string;
}>`
  ${Typography} {
    background-color: ${palette.white};
    border: solid 1px ${palette.gray300};
    border-radius: 5px;
    pointer-events: none;
    padding: 8px;
    font-weight: 500;
    margin-left: 8px;
    white-space: nowrap;
  }
`;
